import styled from 'common/styled-components';
import { FlexDiv } from 'common/flex';
import { FormControl, IconButton } from '@material-ui/core';

export const TimeEntryItem = styled.div`
    /* padding-top: 8px; */
`;

export const TimeEntryListHeader = styled.div`
    display: flex;
    align-items: center;
    /* background: ${props => props.theme.secondary.main}; */
    /* color: ${props => props.theme.secondary.contrastText}; */
    width: 100%;
    /* height: 30px; */
    padding: 0 10   px;
    margin-bottom: 5px;
    margin-top: 5px;
    font-size: 1.1125rem;
    font-weight: 300;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    line-height: 1.16667em;
`;

export const ListDate = styled(FlexDiv)<{selected: boolean; writable: boolean; }>`
    flex: 3;
    align-self: center;
    justify-content: left;
    color: ${props => props.theme.white.contrastText};
    margin-left: 6px;
    cursor: pointer;
    outline: none;
    ${props => props.selected && `font-weight: 400`}
    ${props => props.writable && `pointer-events: none`}
    &:focus {
        font-weight: 500;
    }
`;

export const StyledIconButton = styled(IconButton)`
    && {
        padding: 0;
    }
`;
export const TETotalDuration = styled<
    {justifyContent?: string}, 'div'>('div')`
    display: flex;
    flex: 1;
    align-self: center;
    font-size: 16px;
    ${props => props.justifyContent ? `justify-content: ${props.justifyContent};` : ''};
`;
export const TotalDuration = styled(TETotalDuration)`
    color: ${props => props.theme.white.contrastText};
`;
export const Posted = styled(TETotalDuration)`
    color: ${props => props.theme.summary.green};
`;
export const Draft = styled(TETotalDuration)`
    color: ${props => props.theme.summary.orange};
`;
export const SortEntries = styled(FormControl)`
    && {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
        margin: 0 20px 0 10px;

        .MuiInput-root {
            margin-top: 0;
           vertical-align: middle;
           min-width: 150px;
        }

        .MuiSelect-select {
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            padding: 6px 32px 6px 32px;
        }

        .MuiSelect-icon {
            right: 8px;
        }
    }
`;
